/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPostReserveNotificationReqBodyDto
 */
export interface AdminPostReserveNotificationReqBodyDto {
    /**
     * 제목
     * @type {string}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'title': string;
    /**
     * 내용
     * @type {string}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'content': string;
    /**
     * 링크
     * @type {string}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'link': string;
    /**
     * 알림 대상 카테고리
     * @type {Array<string>}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'targetCategories': Array<AdminPostReserveNotificationReqBodyDtoTargetCategoriesEnum>;
    /**
     * 알림 전송 카테고리
     * @type {Array<string>}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'sendCategories': Array<AdminPostReserveNotificationReqBodyDtoSendCategoriesEnum>;
    /**
     * 개인 지정 알림시 유저 uuid
     * @type {Array<string>}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'targetIds'?: Array<string>;
    /**
     * 예약 일시
     * @type {string}
     * @memberof AdminPostReserveNotificationReqBodyDto
     */
    'scheduledAt': string;
}

export const AdminPostReserveNotificationReqBodyDtoTargetCategoriesEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    AllUser: 'allUser',
    EachUser: 'eachUser'
} as const;

export type AdminPostReserveNotificationReqBodyDtoTargetCategoriesEnum = typeof AdminPostReserveNotificationReqBodyDtoTargetCategoriesEnum[keyof typeof AdminPostReserveNotificationReqBodyDtoTargetCategoriesEnum];
export const AdminPostReserveNotificationReqBodyDtoSendCategoriesEnum = {
    Viewup: 'viewup',
    Sms: 'sms'
} as const;

export type AdminPostReserveNotificationReqBodyDtoSendCategoriesEnum = typeof AdminPostReserveNotificationReqBodyDtoSendCategoriesEnum[keyof typeof AdminPostReserveNotificationReqBodyDtoSendCategoriesEnum];


